module.exports = "/wp-content/plugins/farmacy/assets/js/images/map-marker-delivery-location-d63946b0bb8de364b11f4e922c6c70a3.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/locations-map/img/map-marker-delivery-location.png
 ** module id = 401
 ** module chunks = 1 7 9 33 51
 **/